module.exports = __webpack_public_path__ + "media/2.3f66f66f.mp3";